import './style.css';
import React, { useEffect, useState } from 'react'
import { BASE_ROUTE } from '../../config';
import { Button, Form, FormControl } from 'react-bootstrap';
import { http_request } from '../../libs/connection';
import Progress from '../../components/progress';
import { useLocation, useNavigate } from 'react-router-dom';

function LoginCompany() {
    const navigate = useNavigate();
    const location = useLocation();
    const { pathname } = location;
    const [no, setNo] = useState('');
    const [account, setAccount] = useState('');
    const [password, setPassword] = useState('');
    const [error_message, setErrorMessage] = useState('');
    const [is_loading, setLoadingStatus] = useState(false);

    useEffect(()=>{
        clearForm();
    }, [pathname]);

    function clearForm(){
        setNo('');
        setAccount('');
        setPassword('');
        setErrorMessage('');
    }
    function isValidForm(){
        let q1 = no;
        let q2 = account;
        let q3 = password;
        return q1 && q2 && q3;
    }
    function login(){
        let params = {
            no,
            account,
            password
        };
        setLoadingStatus(true);
        http_request('/company/login', 'POST', params).then(res=>{
            setLoadingStatus(false);
            if(res.success){
                let user = res.data.user;
                user.access_token = res.data.access_token;
                user.cu_no = no;
                localStorage.setItem('user_info_company', JSON.stringify(user));
                navigate(`${BASE_ROUTE}/`);
                setErrorMessage('');
            }else{
                setErrorMessage(res.message);
            }
        });
    }

    return (
        <div id="page-login" className={`py-3 d-flex flex-column justify-content-center page-container`} onKeyUp={e=>{
                let q1 = e.key === 'Enter';
                let q2 = isValidForm();
                if(q1 && q2) login();
            }}>
            <Progress show={is_loading} variant="primary" />
            <h1 className='pt-3 pb-4 text-center'>厂商登入</h1>
            <Form.Group className='mb-3'>
                <FormControl
                    type='text'
                    placeholder='厂商代号'
                    value={no}
                    onChange={e=>{
                        setNo(e.currentTarget.value);
                    }}
                />
            </Form.Group>
            <Form.Group className='mb-3'>
                <FormControl
                    type='text'
                    placeholder='帐号'
                    value={account}
                    onChange={e=>{
                        setAccount(e.currentTarget.value);
                    }}
                />
            </Form.Group>
            <Form.Group className='mb-3'>
                <FormControl
                    type='password'
                    placeholder='密码'
                    value={password}
                    onChange={e=>{
                        setPassword(e.currentTarget.value);
                    }}
                />
            </Form.Group>
            <div className='d-flex flex-column align-items-center justify-content-center my-5'>
                <div className='p-2' style={{ color: 'red', height: 44 }}>{error_message}</div>
                <Button 
                    variant='primary' 
                    className='px-5' 
                    onClick={()=>{ login(); }} 
                    disabled={!isValidForm()}
                >登入</Button>
            </div>
        </div>
    )
}

function LoginERP() {
    const navigate = useNavigate();
    const location = useLocation();
    const { pathname } = location;
    const [account, setAccount] = useState('');
    const [password, setPassword] = useState('');
    const [error_message, setErrorMessage] = useState('');
    const [is_loading, setLoadingStatus] = useState(false);

    useEffect(()=>{
        clearForm();
    }, [pathname]);

    function clearForm(){
        setAccount('');
        setPassword('');
        setErrorMessage('');
    }
    function isValidForm(){
        let q1 = account;
        let q2 = password;
        return q1 && q2;
    }
    function login(){
        let params = {
            account,
            password
        };
        setLoadingStatus(true);
        http_request('/erp/login', 'POST', params).then(res=>{
            setLoadingStatus(false);
            if(res.success){
                let user = res.data.user;
                user.access_token = res.data.access_token;
                localStorage.setItem('user_info_company', JSON.stringify(user));
                navigate(`${BASE_ROUTE}/`);
                setErrorMessage('');
            }else{
                setErrorMessage(res.message);
            }
        });
    }

    return (
        <div id="page-login" className={`py-3 d-flex flex-column justify-content-center page-container`} onKeyUp={e=>{
                let q1 = e.key === 'Enter';
                let q2 = isValidForm();
                if(q1 && q2) login();
            }}>
            <Progress show={is_loading} variant="primary" />
            <h1 className='pt-3 pb-4 text-center'>登入</h1>
            <Form.Group className='mb-3'>
                <FormControl
                    type='text'
                    placeholder='帐号'
                    value={account}
                    onChange={e=>{
                        setAccount(e.currentTarget.value);
                    }}
                />
            </Form.Group>
            <Form.Group className='mb-3'>
                <FormControl
                    type='password'
                    placeholder='密码'
                    value={password}
                    onChange={e=>{
                        setPassword(e.currentTarget.value);
                    }}
                />
            </Form.Group>
            <div className='d-flex flex-column align-items-center justify-content-center my-5'>
                <div className='p-2' style={{ color: 'red', height: 44 }}>{error_message}</div>
                <Button 
                    variant='primary' 
                    className='px-5' 
                    onClick={()=>{ login(); }} 
                    disabled={!isValidForm()}
                >登入</Button>
            </div>
        </div>
    )
}

const Login = LoginCompany;

export default Login;